const DEFAULT_CONTENTSTACK_IMAGE_QUALITY = 75
const DEFAULT_CITRUS_BREAKPOINTS = [640, 768, 1024, 1280]

type ContentstackImageUrlOptions = {
  width?: number
}

export const getContentstackImageWidths = (breakpoints?: string[]) => {
  if (!breakpoints?.length) {
    return DEFAULT_CITRUS_BREAKPOINTS
  }

  return breakpoints
    .map((breakpoint) => Number.parseInt(breakpoint, 10))
    .sort((left, right) => left - right)
}

export const buildContentstackImageUrl = (
  src: string,
  { width }: ContentstackImageUrlOptions = {},
) => {
  const [path, existingSearch = ''] = src.split('?')
  const searchParams = new URLSearchParams(existingSearch)

  searchParams.set('format', 'auto')
  searchParams.set('quality', String(DEFAULT_CONTENTSTACK_IMAGE_QUALITY))

  if (width) {
    searchParams.set('width', String(width))
  }

  return `${path}?${searchParams.toString()}`
}

export const buildContentstackSrcSet = (src: string, widths: number[]) =>
  widths.map((width) => `${buildContentstackImageUrl(src, { width })} ${width}w`).join(', ')

export { DEFAULT_CONTENTSTACK_IMAGE_QUALITY, DEFAULT_CITRUS_BREAKPOINTS }
